import {initSliders} from "./Slider";

/**
 * Страница инноваций
 * ***/

var stagesItems = $('.innovations-stages .stages-list ul li');
var stagesItemsContent = $('.innovations-stages .stages-list ul li .hidden-content');

stagesItems.click(function() {
    var currentHiddenContent = $(this).find('.hidden-content');

    stagesItemsContent
        .not(currentHiddenContent)
        .slideUp(500);

    currentHiddenContent
        .slideDown(500);
});

/* Accordion */
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
        }
    });
}

/* Modals */
var btnModal = $('.btn-modal'),
    btnDirection = $('.btn-direction'),
    btnBack = $('.modal .btn-back'),
    btnCloseModal = $('.modal .close,.modal .popup-close'),
    modalDirection = $('#directionModal'),
    modalDirectionsList = $('#directionsListModal'),
    modalSuccess = $('#successModal');


$(btnModal).each(function(i, btnDom) {
    var btn = $(btnDom);

    btn.on('click', function() {
        var targetModal = $('#' + $(this).attr('data-modal'));
        $('body').addClass('scroll-locked');
        targetModal.css('display', 'block');

        if (btn.is('[data-content-id]')) {
            targetModal
                .find('[data-content-id]')
                .addClass('hidden')
                .filter(`[data-content-id="${btn.data('content-id')}"]`)
                .removeClass('hidden');
        }
    });
});

$(btnCloseModal).each(function() {
    $(this).on('click', function() {
        $('body').removeClass('scroll-locked');
        $(this).parents('.modal').css('display', 'none');
    });
});

modalSuccess.on('click', (e) => {
    if (!$(e.target).closest('.modal-content').length) {
        $('body').removeClass('scroll-locked');
        $(e.target).css('display', 'none');
    }
});

$(btnBack).on('click', function() {
    modalDirection.css('display', 'none');
    modalDirectionsList.css('display', 'block');
    modalDirectionsList.animate({
        scrollTop: 0
    }, 0);
});

$(btnDirection).on('click', function() {
    var title = $(this).find('.title'),
        description = $(this).find('.description').text(),
        direction = $(this).find('.direction'),
        date = $(this).find('.date').text(),
        image = $(this).data('image');

    modalDirection.find('.modal-title').text(title.text());
    modalDirection.find('.description').text(description);
    modalDirection.find('.direction').text(direction);
    modalDirection.find('.date-value').text(date);
    if (image) {
        modalDirection
            .find('.modal-image')
            .show()
            .attr('src', image);
    } else {
        modalDirection
            .find('.modal-image')
            .hide()
            .attr('src', 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==');
    }

    $('#innovations-directionForm').find('#innovations-directionForm__direction option[value=' + direction.attr('data-direction') + ']').prop('selected', true);
    $('#innovations-directionForm').find('#innovations-directionForm__task option[value=' + title.attr('data-task') + ']').prop('selected', true);

    if($(this).hasClass('btn-direction-modal')) {
        modalDirectionsList.css('display', 'none');
        modalDirection.animate({
            scrollTop: 0
        }, 0);
    }

});

var subscribeForm = $('#innovations-subscribeForm'),
    contactForm = $('#innovations-contactForm'),
    directionModalForm = $('#innovations-directionForm'),
    successModalMessage = $('#successModalMessage');

contactForm
    .add(directionModalForm)
    .on('form:error', (e, response) => {
        successModalMessage.html(response.message);
        modalSuccess.css('display', 'block');
        $('body').addClass('scroll-locked');
    })
    .on('form:success', () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(
            {
                "event": "form_submit"
            }
        );
    })
    .add(subscribeForm)
    .on('form:success', (e, response) => {
        successModalMessage.html(response.message);
        modalSuccess.css('display', 'block');
        $('body').addClass('scroll-locked');
    });

subscribeForm.on('form:success', () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(
        {
            "event": "subscription_submit"
        }
    );
});

$(function(){
    var curDown = false,
        curYPos = 0,
        curXPos = 0,
        scrollableBlock = $(".tabbed .tab-wrap");
    scrollableBlock.mousemove(function(m){
        if(curDown === true){
            $(this).scrollTop($(this).scrollTop() + (curYPos - m.pageY));
            $(this).scrollLeft($(this).scrollLeft() + (curXPos - m.pageX));
        }
    });

    scrollableBlock.mousedown(function(m){
        curDown = true;
        curYPos = m.pageY;
        curXPos = m.pageX;
    });

    scrollableBlock.mouseup(function(){
        curDown = false;
    });
});

$('.stages-list li').on('click', function() {
    var caption = $(this).find('.caption');
    var image = caption.attr('data-image');
    var imageSrcset = caption.attr('data-image-srcset');
    $('.innovations-stages img')
        .attr('src', image)
        .attr('srcset', imageSrcset);
});

/* free scroll tabs */
var tabbedInputs = $('.innovations-directions input');

$('.tabbed .swiper-container.tabs').each((i, swiperDom) => {
    var timer;
    var swiper = new Swiper(swiperDom, {
        slidesPerView: 'auto',
        freeMode: true,
        centeredSlides: true,
        centeredSlidesBounds: true,
    });

    $(swiperDom).find('.swiper-slide').on('click', (e) => {
        var slide = $(e.currentTarget);

        swiper.slideTo(slide.index());

        slide.closest('.tabbed').find('> input').eq(slide.index()).prop('checked', true).change();
    });

    App.W.one('load', () => {
        swiper.update();
    });

    $(swiperDom).on('click mousedown touchstart', destroyAutoplay);

    timer = setInterval(function() {
        var index = Array.from(tabbedInputs).findIndex(inputDom => inputDom.checked);

        if (index == tabbedInputs.length - 1) {
            $('.swiper-slide', swiperDom).eq(0).find('label').click();
        } else {
            $('.swiper-slide', swiperDom).eq(index).next().find('label').click();
        }
    }, 7000);

    function destroyAutoplay(e) {
        if (e.originalEvent && e.originalEvent.isTrusted) {
            clearInterval(timer);
            $(swiperDom).off('click mousedown touchstart', destroyAutoplay);
            $('.innovations-directions').addClass('_autoplay-stopped');
        }
    }
});



// WEBPACK FOOTER //
// ./_src/js/InnovationsPage.js